import React, { useState } from 'react';
import * as icons from 's2s-svg-icons-combined';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colorGrid } from 's2s-themes';

const svgIcons = {  ...icons.combinedSVGIcons };

// styles for all CallControl buttons including Mute/Hold if isMuted/isOnHold is false
const WhiteButtonContainer = styled.button`
  font-family: Poppins;
  align-items : center;
  background-color : ${colorGrid.gray0};
  border : 1px solid transparent;
  border-radius : 2px;
  box-sizing: border-box;
  padding: 8px 0;
  color : ${props => {
    let returnColor = colorGrid.gray8;
    
    if(props.disabled) { // Yeah naming isn't consistent with {props.isDisabled} but disabled is an actual button attribute, and I figured this is better than adding seemingly duplicate properties - KCF
      returnColor = colorGrid.gray4;
    }
    return returnColor;
  }};
  cursor : pointer;
  display : flex;
  flex-direction : column;
  font-size : 14px;
  height : 72px;
  justify-content: space-between;
  width : 96px;
  outline: none;
  
  ${({ isActive }) => isActive && `
    background: rgba(36, 57, 145, 0.08);
    border: 1px solid #A7B4E9;
    box-sizing: border-box;
    border-radius: 4px;
  `}

  &:hover {
    background: rgba(36, 57, 145, 0.04);
  }

  &:focus {
    background: rgba(36, 57, 145, 0.08);
    border: 1px solid #A7B4E9;
    box-sizing: border-box;
    border-radius: 4px;
  }
`;

const Label = styled.div`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.1px;
  color: ${({ isFocus }) => isFocus ? '#243991' : '#4C5863' };
`;

const CallControlButton = (props) => {

  const [isFocus, setIsFocus ] = useState(false); // Cannot use styled-components to override pseudo state styles due to s2s-svgs using old component styling methods. - KCN

  const handleToggleFocus = () => {
    setIsFocus(!isFocus);
  };

  const renderSVG = (buttonType, isDisabled) => {
    if (typeof svgIcons[props.svgType] !== "undefined") {
      const DynamicSVG = svgIcons[props.svgType];

      // This just seems easier to read than some crazy trinary. - KCN
      const focusedFill = isFocus ? '#243991' : '#001221';
      const disabledFill = isDisabled === true ? colorGrid.gray4 : focusedFill;
      const typeFill = buttonType === "white" ? disabledFill : '#243991';

      return (
        <DynamicSVG
          className={props.svgType}
          svgStyle={{
            fill: typeFill,
            height: '30px',
            width: '30px'
          }}
        />
      );
    }
  };

  const handleClick = () => {
    if(!props.isDisabled) {
      props.cbClick();
    }
  };
  
  return (
    <WhiteButtonContainer
      className="CallControlButtonContainer"
      disabled={props.isDisabled} // NOTE naming is a bit inconsistent disabled => isDisabled - KCN
      onClick={handleClick}
      onFocus={handleToggleFocus}
      onBlur={handleToggleFocus}
      isActive={props.buttonType !== 'white'}
    >
      {renderSVG(props.buttonType, props.isDisabled )}
      <Label className="Label" isFocus={isFocus}>
        {props.label}
      </Label>
    </WhiteButtonContainer>
  );
};

CallControlButton.propTypes = {
  buttonType : PropTypes.string,
  cbClick : PropTypes.func,
  isDisabled : PropTypes.bool,
  intl: PropTypes.object,
  label : PropTypes.string,
  svgType : PropTypes.string
};

CallControlButton.defaultProps = {
  buttonType : "white",
  cbClick : ()=> { console.log("cbClick in CallControls not defined ");},
  isDisabled : false,
  label : "",
  svgType : 'AddIconSVG',
};

export default CallControlButton;
